import { Refresh } from "@browser/Browser";
import * as rt from "@common/AppRT";
import { ICommandStatus } from "@cqrs/cqrs";
import MeetingQuestionReview from "@Evaluation/AlternativesSurveys/Components/MeetingQuestionReview.vue";
import { SavePanelistVoteCommandV1, SavePanelistVoteCommentCommandV1 } from "@Evaluation/AlternativesSurveys/Domain/commands-core";
import ScoringCommands from '@Evaluation/AlternativesSurveys/Domain/commands-vue-component';
import ScoringQueries from '@Evaluation/AlternativesSurveys/Domain/queries-vue-component';
import { MeetingQuestionReviewReadModel, PanelistMeetingPageReadModel, ScoringVoteEntry, ScoringVoteReadModel } from '@Evaluation/AlternativesSurveys/Domain/readmodels';
import { IEvaluationCommand } from "@Evaluation/cqrs";
import Component, { mixins } from 'vue-class-component';

@Component({
    components: { MeetingQuestionReview }
})
export default class PanelistMeetingPage extends mixins(ScoringCommands, ScoringQueries) {

    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get surveyId(): number { return Number.parseInt(this.$route.params.surveyId); }
    get projectUserId(): number { return Number.parseInt(this.$route.params.projectUserId); }

    handler: any = null;
    SavingCommentHandle: any = null;
    connecting: boolean = true;
    initialized: boolean = false;
    meetingStarted: boolean = false;

    rm: PanelistMeetingPageReadModel = null;
    get question() { return this.rm.Question; }
    get dashboardUrl() { return this.rm.DashboardUrl; }
    get surveyStarted() { return this.rm.SurveyStarted; }
    get votesEntries(): ScoringVoteEntry[] { return this.rm?.Question?.VotesEntries ?? null; }
    get viewTemplate(): string
    {
        if (this.connecting === true) { return "connecting"; }
        else if (this.connecting === false && this.initialized === true && this.meetingStarted === false) { return "notStarted"; }
        else { return "default"; }
    }


    SetQuestion(question: MeetingQuestionReviewReadModel)
    {
        const self = question.VotesEntries?.find(a => a.ProjectUserId === this.projectUserId) ?? null;

        if (self != null)
        {
            self.VotesSourceName = "Me";
        }

        this.rm.Question = question;
        this.loadVote();
    }

    SetQuestionVotes(question: MeetingQuestionReviewReadModel)
    {
        if (this.question.Id === question.Id)
        {
            const self = question.VotesEntries?.find(a => a.ProjectUserId === this.projectUserId) ?? null;

            if (self != null)
            {
                self.VotesSourceName = "Me";
            }

            this.question.VotesEntries = question.VotesEntries;
        }
    }

    SetVotesBrowserEntry(entry: ScoringVoteEntry)
    {
        if (this.question.Id === entry.QuestionId)
        {
            const current = this.votesEntries.find(a => a.ProjectUserId === entry.ProjectUserId);
            current.Value = entry.Value;
            current.Comment = entry.Comment;
        }
    }


    loadVote()
    {
        this.runPanelistVoteQueryV1(this.workspaceId, this.projectUserId, this.question.Id);
    }

    handleSavePanelistVoteCommentCommand(comment: string)
    {
        this.question.Comment = comment;

        if (this.SavingCommentHandle == null)
        {
            this.SavingCommentHandle = setTimeout(() =>
            {
                this.invokeSavePanelistVoteCommentCommandV1(this.workspaceId, this.surveyId, this.projectUserId, this.question.Id, this.question.Comment);
                this.SavingCommentHandle = null;
            }, 1000);
        }
    }

    handleSavePanelistVoteCommand(value: number)
    {
        this.question.Value = value;
        this.invokeSavePanelistVoteCommandV1(this.workspaceId, this.surveyId, this.projectUserId, this.question.Id, this.question.Value, this.question.Comment);
    }

    mounted()
    {
        //document.title = "Panelists | TransparentChoice";

        this.handler = rt.subscribeModule("AlternativesSurveys.MeetingPanelist",
            {
                MeetingStopped: (data: any) =>
                {
                    if (this != null)
                    {
                        Refresh();
                    }
                },
                MeetingStarted: (data: MeetingQuestionReviewReadModel) =>
                {
                    if (this.meetingStarted === false)
                    {
                        this.connecting = false;
                        this.meetingStarted = true;
                        this.SetQuestion(data);
                    }
                },
                SetQuestion: (data: MeetingQuestionReviewReadModel) =>
                {
                    if (this != null)
                    {
                        this.SetQuestion(data);
                    }
                },
                SetQuestionVotes: (data: MeetingQuestionReviewReadModel) =>
                {
                    if (this != null)
                    {
                        this.SetQuestionVotes(data);
                    }
                },
                SetVoteEntry: (data: ScoringVoteEntry) =>
                {
                    if (this != null)
                    {
                        this.SetVotesBrowserEntry(data);
                    }
                },
            });

        this.runPanelistMeetingPageQueryV1(this.workspaceId, this.surveyId, this.projectUserId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "PanelistMeetingPageReadModel")
        {
            this.rm = model as PanelistMeetingPageReadModel;

            const handle = setTimeout(() =>
            {
                this.connecting = false;
                clearTimeout(handle);
            }, 10000);

            this.requestMeetingStatus();
            this.initialized = true;
        }
        else if (modelName == "ScoringVoteReadModel")
        {
            const vote = model as ScoringVoteReadModel;

            if (this.question.Id === vote.QuestionId)
            {
                this.question.Value = vote.Value;
                this.question.Comment = vote.Comment;
            }
        }
    }

    onCommandSucceed(cmd: IEvaluationCommand, correlationId: string, result: any)
    {
        if (SavePanelistVoteCommandV1.matchType(cmd))
        {
            const cmd1 = cmd as SavePanelistVoteCommandV1;
            this.notifyVoteValueChanged(cmd1.QuestionId, cmd1.VoteValue);
        }
        else if (SavePanelistVoteCommentCommandV1.matchType(cmd))
        {
            const cmd1 = cmd as SavePanelistVoteCommentCommandV1;
            this.notifyVoteCommentChanged(cmd1.QuestionId, cmd1.Comment);
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        //if (UpdateCriterionCommandV1.matchType(status.Command))
        //{
        //    this.displayValidationErrors(status.ValidationErrors);
        //}
    }


    requestMeetingStatus()
    {
        rt.send("AlternativesSurveys.MeetingPanelist", "RequestMeetingStatus",
            {
                WorkspaceId: this.workspaceId,
                SurveyId: this.surveyId,
                ProjectUserId: this.projectUserId,
            });
    }

    notifyVoteValueChanged(questionId: number, value: number | null)
    {
        rt.send("AlternativesSurveys.MeetingPanelist", "NotifyVoteValueChanged",
            {
                WorkspaceId: this.workspaceId,
                SurveyId: this.surveyId,
                ProjectUserId: this.projectUserId,
                QuestionId: questionId,
                VoteValue: value
            });
    }

    notifyVoteCommentChanged(questionId: number, comment: string)
    {
        rt.send("AlternativesSurveys.MeetingPanelist", "NotifyVoteCommentChanged",
            {
                WorkspaceId: this.workspaceId,
                SurveyId: this.surveyId,
                ProjectUserId: this.projectUserId,
                QuestionId: questionId,
                Comment: comment
            });
    }


    beforeDestroy()
    {
        if (this.handler)
        {
            rt.unsubscribe(this.handler);
        }
    }
}